import { render, staticRenderFns } from "./InfoBoxBuilder.vue?vue&type=template&id=8e762d06&scoped=true"
import script from "./InfoBoxBuilder.vue?vue&type=script&lang=js"
export * from "./InfoBoxBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e762d06",
  null
  
)

export default component.exports